/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Editor.ts
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1731
 * ---
 */

import {configureStore} from '@reduxjs/toolkit';
import {authSlice} from './slices/auth-slice';
import {loadingSlice} from './slices/loading-slice';
import {catch401, catch403, catch404, catchErrors} from './middleware';
import {projectDataSlice} from "./slices/projectdata-slice";

/**
 * Raccoglie lo stato dell'work-area 2d in modo ordinato ed elegante
 */
export const store = configureStore({
  reducer: {
    authState: authSlice,
    loadingState: loadingSlice,
    projectCreate: projectDataSlice
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      catch401,
      catch403,
      catch404,
      catchErrors
    );
  }
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = ReturnType<typeof store.dispatch>
